import React, { Component } from 'react'
import injectSheet from 'react-jss'
import styles from './request.styles'
import Button from 'pobble-components/dist/button'
import Segment from '../../../../shared/segment/segment'
import Segments from '../../../../shared/segments/segments'
import Form from './form/form.container'

class Request extends Component {
  constructor(props) {
    super(props)
    this.state = { openForm: this.props.pendingTeacher }
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        {!this.state.openForm && (
          <Segments className={classes.segments}>
            <Segment size={'L'}>
              <div>
                <Button
                  tall
                  className={classes.button}
                  action={() => this.setState({ openForm: true })}>
                  I'm a teacher
                </Button>
              </div>
            </Segment>
          </Segments>
        )}
        {this.state.openForm && <Form />}
      </div>
    )
  }
}

export default injectSheet(styles)(Request)
